/**
 * PLAIN — Custom Theme JavaScript
 * Countdown Timer + Scroll Reveal Animations
 */

/* --- Countdown Timer Web Component --- */
class PlainCountdown extends HTMLElement {
  constructor() {
    super();
    this.endDate = null;
    this.interval = null;
  }

  connectedCallback() {
    const dateStr = this.dataset.end;
    if (!dateStr) return;

    this.endDate = new Date(dateStr).getTime();
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minsEl = this.querySelector('[data-mins]');
    this.secsEl = this.querySelector('[data-secs]');
    this.timerEl = this.querySelector('.countdown__timer');
    this.expiredEl = this.querySelector('.countdown__expired');

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  update() {
    const now = Date.now();
    const diff = this.endDate - now;

    if (diff <= 0) {
      if (this.interval) clearInterval(this.interval);
      if (this.timerEl) this.timerEl.style.display = 'none';
      if (this.expiredEl) this.expiredEl.style.display = 'block';
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((diff % (1000 * 60)) / 1000);

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minsEl) this.minsEl.textContent = String(mins).padStart(2, '0');
    if (this.secsEl) this.secsEl.textContent = String(secs).padStart(2, '0');
  }
}
customElements.define('plain-countdown', PlainCountdown);

/* --- Gift Wrap Toggle --- */
class PlainGiftWrap extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('.gift-wrap__checkbox');
    this.messageBox = this.querySelector('.gift-wrap__message');
    if (this.checkbox && this.messageBox) {
      this.checkbox.addEventListener('change', () => {
        this.messageBox.classList.toggle('is-active', this.checkbox.checked);
      });
    }
  }
}
customElements.define('plain-gift-wrap', PlainGiftWrap);

/* --- Scroll Reveal Observer --- */
document.addEventListener('DOMContentLoaded', () => {
  const reveals = document.querySelectorAll('.plain-reveal');
  if (!reveals.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  reveals.forEach((el) => observer.observe(el));
});
